import { Context } from "../Reducers/Store";
import React, { useCallback, useState, useEffect, useContext } from "react";
import { ToastContainer, Toast } from 'react-bootstrap';

function Toasts() {
    const [state, dispatch] = useContext(Context);

    useEffect(() => {
    }, [state.toast]);

    const handleClose = (msg) => {
        let newToasts = state.toast?.filter(x => x != msg) || [];
        dispatch({ type: "SET_TOAST", payload: newToasts });
    }

    return (
        <div aria-live="polite" aria-atomic="true">
            <ToastContainer position="top-end" className="p-3">
                {state.toast?.map((m, index) => (
                    <Toast key={index} delay={m.delay || 7000} autohide={true} onClose={x => handleClose(m)}>
                        <Toast.Header closeButton={true}>
                            <strong className="me-auto">{m.title}</strong>
                        </Toast.Header>
                        <Toast.Body>{m.message}</Toast.Body>
                    </Toast>
                ))}
            </ToastContainer>
        </div>
    );
}
export default Toasts;